import { render, staticRenderFns } from "./NewClassSelect.vue?vue&type=template&id=00cb1e81&"
import script from "./NewClassSelect.vue?vue&type=script&lang=js&"
export * from "./NewClassSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports